export default __webpack_public_path__ + "static/media/is.8bc19a21.svg";